
<template>
  <div class="empty">
    <VantEmpty :description="assetsConfig.no_content || '暂无内容，敬请期待。'"></VantEmpty>
  </div>
</template>

<script>
import { Empty } from "vant";

export default {
  data() {
    return {
      assetsConfig: {},
    };
  },
  created() {
    window.OnConfigFnc((getConfig) => {
      const Config = getConfig(window.brand) || {
        no_content: "暂无内容，敬请期待。",
        first_screen: { bg: "" },
      };
      if (Config.first_screen && Config.first_screen.bg) {
        this.$router.replace({ path: "./", query: this.$route.query });
      }
      this.assetsConfig = Config;
    });
  },
  computed: {},
  methods: {},
  components: {
    VantEmpty: Empty,
  },
};
</script>

<style lang="scss" scoped>
</style>
<style lang="scss">
</style>